import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

const craftPrinciples = [
  {
    number: "01",
    title: "Purpose-built cloth",
    copy: "We choose substantial fabrics for their strength, character and ability to become more personal with every wear.",
  },
  {
    number: "02",
    title: "Uncompromising construction",
    copy: "Stress points are reinforced, seams are considered and every detail earns its place in the finished garment.",
  },
  {
    number: "03",
    title: "Repair. Wear. Repeat.",
    copy: "The best clothing records a life well lived. We design for years of use, honest fading and repair over replacement.",
  },
];

const brandInitials = siteConfig.brandName
  .split(/\s+/)
  .map((word) => word.charAt(0))
  .join("")
  .slice(0, 2);

function About() {
  return (
    <main className="about" aria-labelledby="about-title">
      <section className="about__hero">
        <div className="about__hero-copy">
          <p className="about__eyebrow">{siteConfig.tagline}</p>
          <h1 id="about-title">
            {siteConfig.brandName}
            <span>Made to live in.</span>
          </h1>
        </div>
        <div className="about__manifesto">
          <p>
            We make honest clothing for people who expect more from what they
            wear. Every piece starts with a clear purpose and is built to gain
            character, not lose it.
          </p>
          <Link className="about__text-link" to="/shop">
            Explore the collection <span aria-hidden="true">→</span>
          </Link>
        </div>
      </section>

      <section className="about__story" aria-labelledby="about-story-title">
        <div className="about__story-marker" aria-hidden="true">
          {brandInitials}
        </div>
        <div className="about__story-copy">
          <p className="about__section-label">Our story</p>
          <h2 id="about-story-title">The long way is the right way.</h2>
          <div className="about__story-columns">
            <p>
              {siteConfig.brandName} is grounded in a simple belief: everyday
              garments should be made with the same focus as specialist workwear.
              That means substantial materials, thoughtful patterns and no
              shortcuts where durability matters.
            </p>
            <p>
              Our collections draw on motorcycle culture, utility clothing and
              the evolving beauty of raw denim. The result is clothing that feels
              dependable from day one and tells a richer story after thousands of
              miles.
            </p>
          </div>
        </div>
      </section>

      <section className="about__principles" aria-labelledby="principles-title">
        <div className="about__section-heading">
          <p className="about__section-label">How we work</p>
          <h2 id="principles-title">Three principles. No compromise.</h2>
        </div>
        <div className="about__principle-grid">
          {craftPrinciples.map((principle) => (
            <article className="about__principle" key={principle.number}>
              <span>{principle.number}</span>
              <h3>{principle.title}</h3>
              <p>{principle.copy}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="about__closing" aria-label="Shop our collection">
        <div>
          <p className="about__section-label">Built for the journey</p>
          <h2>Wear it hard. Make it yours.</h2>
        </div>
        <Link className="about__button" to="/shop">
          Shop all products
        </Link>
      </section>
    </main>
  );
}

export default About;
